import angular from 'angular'

import envRaw from '../utils/env-raw'

import Template from './gallery-vote-count.component.ejs'

angular
  .module('ggs.gallery-vote-count')
  .component('ggsGalleryVoteCount', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryVoteCountComponent,
    bindings: {
      ggsPost: '<',
      ggsProperties: '<',
      ggsPostVoteEmitter: '<',
      ggsVoteCountTheme: '<'
    }
  })

const NAME_TO_CLASS = {
  dark_theme: 'ggs-gallery-vote-count__dark-theme',
  bright_theme: 'ggs-gallery-vote-count__bright-theme'
}

function GalleryVoteCountComponent($scope, pluralize, locale) {
  const $ctrl = $scope.$ctrl = this

  const votesCountWhen = {
    one: () => `${locale.shortNumber(1)} ${$ctrl.ggsProperties.complete_message_bundle.votes_singular}`,
    other: (count) => `${locale.shortNumber(count)} ${$ctrl.ggsProperties.complete_message_bundle.votes_plural}`
  }

  $ctrl.themeClass = NAME_TO_CLASS[$ctrl.ggsVoteCountTheme]
  $ctrl.getVotesCount = () => pluralize(votesCountWhen, $ctrl.ggsPost.votes_count)
}
